import { render } from "./ClientwebPlayer.vue?vue&type=template&id=5657ca3a&scoped=true"
import script from "./ClientwebPlayer.vue?vue&type=script&lang=js"
export * from "./ClientwebPlayer.vue?vue&type=script&lang=js"

import "./ClientwebPlayer.vue?vue&type=style&index=0&id=5657ca3a&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5657ca3a"]])

export default __exports__